import { useAppSelector } from "../hooks";

export const useGetProductGroupDefault = () => {
  const { data, status } = useAppSelector(
    ({ payment }) => payment.productGroupDefault
  );

  return {
    data,
    status,
  };
};

export const useGetProductGroupByPromoCode = () => {
  const { data, status } = useAppSelector(
    ({ payment }) => payment.productGroupByPromoCode
  );

  return {
    data,
    status,
  };
};

export const useGetFeaturesByPlanId = () => {
  const { data, status } = useAppSelector(
    ({ payment }) => payment.featuresByPlanId
  );

  return {
    data,
    status,
  };
};

export const useCreateMyPaymentIntent = () => {
  const { data, status } = useAppSelector(
    ({ payment }) => payment.createMyPaymentIntent
  );

  return {
    data,
    status,
  };
};

export const useCreateBehaviourEvent = () => {
  const { data, status } = useAppSelector(
    ({ payment }) => payment.createBehaviourEvent
  );

  return {
    data,
    status,
  };
};
